/*
 *  History
*/

import createHistory from 'history/createBrowserHistory';

export default createHistory({
  forceRefresh: false // true
});



// WEBPACK FOOTER //
// ./src/history.tsx